import React from 'react'
import { Stack, Typography } from '@mui/material'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'

interface ChartErrorOverlayProps {
    message: string
}

const ChartErrorOverlay: React.FC<ChartErrorOverlayProps> = ({ message }) => {
    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
                pointerEvents: 'auto',
            }}
        >
            <Stack alignItems="center" gap={1}>
                <WarningAmberRoundedIcon
                    sx={{ fontSize: 36, color: 'warning.main', opacity: 0.85 }}
                />
                <Typography
                    variant="body2"
                    color="text.secondary"
                    textAlign="center"
                    sx={{ maxWidth: 280, lineHeight: 1.5 }}
                >
                    {message}
                </Typography>
            </Stack>
        </div>
    )
}

export default ChartErrorOverlay
